import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import api from '../../../api';

const TimezoneSelect = ({
    value,
    onChange,
    error = '',
    label = 'Timezone',
    className = '',
    disabled = false,
    setLoading,
}) => {
    const [timezones, setTimezones] = useState([]);

    useEffect(() => {
        const loadTimezones = async () => {
            try {
                setLoading(true); // start loading
                const response = await api.outbound.getTimezones();
                if (response?.status && response?.data) {
                    const transformed = Object.entries(response.data)
                        .map(([value, label]) => ({ value, label }))
                        .sort((a, b) => a.label.localeCompare(b.label));
                    setTimezones(transformed);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false); 
            }
        };

        loadTimezones();
    }, []);

    const transformTimezones = (data) => {
        return Object.entries(data)
            .map(([value, label]) => ({ value, label }))
            .sort((a, b) => a.label.localeCompare(b.label));
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            borderColor: error ? '#dc3545' : '#e1e5e9',
            borderRadius: 5,
            padding: 2,
            fontSize: 14,
            boxShadow: 'none',
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
        indicatorsContainer: () => ({
            display: 'none',
        }),
    };

    return (
        <div className="form-group" style={{ marginBottom: 10 }}>
            <label className="pd10botbuilder">{label}</label>
            <Select
                className={className}
                styles={customStyles}
                value={timezones.find((tz) => tz.value === value)}
                onChange={(selected) => onChange(selected?.value)}
                options={timezones}
                isSearchable
                isDisabled={disabled}
                placeholder="Select Timezone"
                components={{ DropdownIndicator: null, IndicatorSeparator: null, ClearIndicator: null }}
            />
            {error && (
                <div
                    className="error invalid-feedback d-block"
                    style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}
                >
                    {error}
                </div>
            )}
        </div>
    );
};

export default TimezoneSelect;
